import { render } from "./homeAiAide.vue?vue&type=template&id=27e9f53e&scoped=true"
import script from "./homeAiAide.vue?vue&type=script&lang=js"
export * from "./homeAiAide.vue?vue&type=script&lang=js"

import "./homeAiAide.vue?vue&type=style&index=0&id=27e9f53e&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e9f53e"]])

export default __exports__